import customForm from './modules/custom-form';
import { loadScriptWhenIntersecting } from './modules/dynamic-scripts';
import './modules/orbit';
import './modules/section';
import './modules/video';
import smoothScroll from './utilities/modules/smooth-scroll';
import { waitForElement } from './utilities/modules/wait-for-element';

// Load scripts dynamically
window.addEventListener('load', () => {
	document.querySelectorAll('[data-script-dependencies]').forEach((el) => {
		const dataValue = el.getAttribute('data-script-dependencies');
		const dependencies = dataValue.split(',');
		loadScriptWhenIntersecting(`[data-script-dependencies="${dataValue}"]`, dependencies);
	});
});

customForm();
smoothScroll();

/**
 * Search on 404 pages
 *
 * Transforms the URL path to a string that can be used in the search.
 */
(() => {
	if (document.querySelector('body').classList.contains('error404')) {
		waitForElement('main .site-search input[type="text"]').then((searchInputField) => {
			const url = new URL(window.location);
			if (url.pathname && url.pathname.length > 2) {
				const searchString = url.pathname
					.replace(/\/de\/|\/en\//, '') // Replace
					.replaceAll('-', ' ')
					.replaceAll('/', ' ')
					.trim();

				searchInputField.value = searchString;
				searchInputField.dispatchEvent(new Event('input'));
			}
		});
	}
})();
